// src/components/ExpertiseCard.js
import React from 'react';
import '../styles/ExpertiseCard.css';

function ExpertiseCard({ title, description, image, people }) {
  // fallback for the expertise image
  const handleImageError = (event) => {
    event.target.src = '/default_project.png'; // default fallback image
  };

  return (
    <div className="expertise-card">
      <div className="expertise-image">
        <img src={image} alt={`${title}`} onError={handleImageError} />
      </div>
      <div className="expertise-info">
        <h2 className="expertise-title">{title}</h2>
        <p className="expertise-description">{description}</p>
        <div className="expertise-people">
          <strong>People involved:</strong>
          <ul>
            {people.map((person, index) => (
              <li key={index}>{person.name}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ExpertiseCard;
